import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { SEARCH_FIELD_BOX_PADDING } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programItemsWrapper: {},
  programItemsListSearch: {
    marginTop: SEARCH_FIELD_BOX_PADDING,
  },

  programAddButton: {
    minWidth: 'unset',
    fontSize: '40px',
    fontWeight: 600,
    padding: '0px 4px',
    lineHeight: '35px',
  },
  buttonWeb: {
    display: 'block',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
